// import React, { useEffect, useState, useContext } from 'react';
// import { NavLink, useLocation, useParams, Outlet } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import parse from "html-react-parser";
// import { motion } from "framer-motion/dist/framer-motion"
// import motionConf from '../_motionConf';
// import Loader from '../partials/Loader';
import { CarrouselProject } from '../partials/CarrouselProject';

export default function Projet({ id, nextProjet }) {

  const location = useLocation();
  // let { id } = useParams();
  const [isLoading, setLoading] = useState(true);

  const [projet, setProjet] = useState({});
  const [lang, setLang] = useState("fr"); // possibly useless
  const [content, setContent] = useState("");
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [client, setClient] = useState([]);
  const [missions, setMissions] = useState([]);
  const [avancements, setAvancements] = useState([]);
  const [nextId, setNextId] = useState(false);
  const [jobTitle, setJobTitle] = useState([]);
  const [nextTitle, setNextTitle] = useState("");
  const [nextJobTitle, setNextJobTitle] = useState("");
  const [nextThumbnail, setNextThumbnail] = useState("");

  const getVideoId = (url) => url.indexOf('youtu') ? url.substr('https//www.youtube.com/embed/'.length, url.length) : url;

  // Change language
  useEffect(() => {
    setLoading(true);
    const fetchProjet = async () => {
      let _lang = location.hash ? location.hash.replace("#", "").toLocaleLowerCase() : "fr";
      // Fetch datas
      // const data = await fetch(`https://bigl-architectes.fr/wp-json/wp/v2/project/${id}?lang=${_lang}&acf_format=standard`);
      const data = await fetch(`https://bigl-architectes.fr/wp-json/wp/v2/project/${id}?acf_format=standard`);
      const _projet = await data.json();

      // Multilang content
      if (_projet.translations !== undefined) {
        setContent(_projet.translations[_lang]["content"]);
        setClient(_projet.translations[_lang]["client"]);
        setMissions(_projet.translations[_lang]["missions"]);
        setAvancements(_projet.translations[_lang]["avancements"]);
        setJobTitle(_projet.translations[_lang]["title"]);
        setProjet(_projet);
      }
      setLoading(false);
    }
    fetchProjet().catch(console.error);

  }, [location.hash]);

  // Get project
  useEffect(() => {

    // Set default Language
    let _lang = location.hash ? location.hash.replace("#", "").toLocaleLowerCase() : "fr";

    // Set project datas
    const fetchProjet = async () => {
      // Fetch datas
      // const data = await fetch(`https://bigl-architectes.fr/wp-json/wp/v2/project/${id}?lang=${_lang}&acf_format=standard`);
      const data = await fetch(`https://bigl-architectes.fr/wp-json/wp/v2/project/${id}?acf_format=standard`);
      const _projet = await data.json();

      // Multilang content
      if (_projet?.translations !== undefined && _projet.translations[_lang]) {
        setContent(_projet.translations[_lang]["content"]);
        setClient(_projet.translations[_lang]["client"]);
        setMissions(_projet.translations[_lang]["missions"]);
        setAvancements(_projet.translations[_lang]["avancements"]);
        setJobTitle(_projet.translations[_lang]["title"]);
        setProjet(_projet);
      }

      // Preload 1 images from gallery
      let gallery_images = _projet.acf?.project_gallery;
      let maxLoad = 1;
      let loaded = 0;

      if (gallery_images) {

        for (const source of gallery_images) {
          if (loaded < maxLoad && source.image !== undefined) {
            const img = new Image();
            img.src = source.image.sizes.medium;
            loaded++;
          }
          else
            break;
        }

        // Set Images
        let _imgs = gallery_images.map((item) => {
          let image = item.image;
          return {
            id: image.ID,
            url: image.url,
            alt: image.alt,
            description: image.description
          }
        }).filter((image) => {
          return image.id !== undefined
        })
        setImages(_imgs);

        // Set videos
        let _vids = gallery_images.filter((video) => {
          return video.youtube_video_url.length > 0 || video.video.length > 0
        }).map((video) => {
          if (video.video) return {
            id: video.video,
            url: video.video
          }
          else if (video.youtube_video_url) return {
            id: getVideoId(video.youtube_video_url),
            url: video.youtube_video_url
          }
        })
        setVideos(_vids);
      }

      setLoading(false);
    }

    fetchProjet().catch(console.error);

  }, []);

  // Next content preview
  useEffect(() => {
    // Set default Language
    let _lang = location.hash ? location.hash.replace("#", "").toLocaleLowerCase() : "fr";

    // Set project datas
    // console.log(nextProjet)
    setNextId(nextProjet.id);
    setNextTitle(nextProjet.title.rendered);
    setNextJobTitle(nextProjet.translations[_lang]["title"]);
    setNextThumbnail(nextProjet.next_image_url);
  }, []);

  // get link to next project
  const getLink = (id) => {
    return `/projets/${id}${location.hash}`;
  }

  // The current width of the viewport
  const width = window.innerWidth;
  // The width below which the mobile view should be rendered
  const breakpoint = 821;
  const isMobile = width < breakpoint
  // startPos = isMobile ? null : startPos 

  // return isLoading ? (
  //   <Loader />
  // )  : ( 
  return (!isLoading && (
    <>
      <h1 key="project-title">{projet.title.rendered}</h1>
      <CarrouselProject videos={videos} images={images} key={`project-carousel-${id}`} isMobile={isMobile} />
      <div className="is-nowrap is-layout-flex project-info" key={`project-meta-${id}`} >
        <div className="clients">
          {client}
        </div>
        <div className="job-title">
          {jobTitle}
        </div>
        <div className="missions">
          {missions}
        </div>
        <div className="state">
          {avancements}
        </div>
      </div>

      <div className='post-content' key={`project-content-${id}`} >
        {parse(content)}
      </div>

      <div className='next-post-preview' key={`project-next-${id}`} >

        <div className="is-nowrap is-layout-flex project-info next-project">
          <div className="title"><NavLink to={getLink(nextId)} >{nextTitle}</NavLink></div>
          <div className="job-title"><NavLink to={getLink(nextId)} >{nextJobTitle}</NavLink></div>
          <div className="thumbnail"><NavLink to={getLink(nextId)} ><img src={nextThumbnail} /></NavLink></div>
        </div>

      </div>

    </>
  ))
}